import React from "react";

export interface GeneratePromptButtonProps {
  existingPrompt: string;
  onSubmit: (prompt: string) => void;
}

// Implementation is in ee
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const GeneratePromptButton = (props: GeneratePromptButtonProps) => {
  return <div />;
};
